import { render } from "./workStart2024.vue?vue&type=template&id=377c61c4&scoped=true"
import script from "./workStart2024.vue?vue&type=script&lang=ts"
export * from "./workStart2024.vue?vue&type=script&lang=ts"

import "./workStart2024.vue?vue&type=style&index=0&id=377c61c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-377c61c4"

export default script